var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from "lodash";
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var GroupController = {
    /*****************************************************************************************************
        * Is using route "api/group/for/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {string}
    ******************************************************************************************************/
    GetGroupIdForId: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/for/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group" and http method "GET" to call the back-end.
    
        * @returns {ExtendedDataCollection<GroupDownloadDto, UserProfileSettingsDownloadDto>}
    ******************************************************************************************************/
    Get: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group/last/{userid}" and http method "GET" to call the back-end.
    
        * @param {string} userid
        * @returns {GroupDownloadDto}
    ******************************************************************************************************/
    GetLastGroup: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/last/{userid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group/type" and http method "GET" to call the back-end.
    
        * @returns {string[]}
    ******************************************************************************************************/
    GetGroupType: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/type", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group/user/{groupid}/{userid}" and http method "DELETE" to call the back-end.
    
        * @param {string} groupid
        * @param {string} userid
        * @returns {void}
    ******************************************************************************************************/
    DeleteUserFromGroup: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/user/{groupid}/{userid}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group/{groupid}/{userid}" and http method "PATCH" to call the back-end.
    
        * @param {string} groupid
        * @param {string} userid
        * @param {string[]} roles
        * @returns {UserShortInfoDownloadDto}
    ******************************************************************************************************/
    ChangeUserRightsInGroup: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/{groupid}/{userid}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.roles
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group/{groupid}" and http method "DELETE" to call the back-end.
    
        * @param {string} groupid
        * @returns {void}
    ******************************************************************************************************/
    Delete: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/{groupid}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {GroupDownloadDto}
    ******************************************************************************************************/
    GetGroup: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group/join/{itemid}" and http method "GET" to call the back-end.
    
        * @param {string} itemid
        * @returns {ExtendedDataCollection<GroupDownloadDto, UserProfileSettingsDownloadDto>}
    ******************************************************************************************************/
    JoinForItem: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/join/{itemid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group/hierarchy" and http method "GET" to call the back-end.
    
        * @returns {DataCollection<GroupDownloadDto>}
    ******************************************************************************************************/
    GetHierarchy: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/hierarchy", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group/roles/{groupId}" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @returns {Roles}
    ******************************************************************************************************/
    GetGroupRoles: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/roles/{groupId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group/role/{groupId}/{roleName}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} roleName
        * @param {RoleDefinition} roleDefinition
        * @returns {Roles}
    ******************************************************************************************************/
    AddGroupRole: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/role/{groupId}/{roleName}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.roleDefinition
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group/role/{groupId}/{roleName}" and http method "PATCH" to call the back-end.
    
        * @param {string} groupId
        * @param {string} roleName
        * @param {RoleDefinition} roleDefinition
        * @returns {Roles}
    ******************************************************************************************************/
    UpdateGroupRole: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/role/{groupId}/{roleName}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.roleDefinition
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group/role/{groupId}/{roleName}" and http method "DELETE" to call the back-end.
    
        * @param {string} groupId
        * @param {string} roleName
        * @returns {Roles}
    ******************************************************************************************************/
    DeleteGroupRole: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/role/{groupId}/{roleName}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group/{parent}" and http method "POST" to call the back-end.
    
        * @param {string} parent
        * @param {GroupUploadDto} group
        * @param {File} media
        * @param {File} sysInvFile
        * @param {File} groupInvFile
        * @param {File} resetPwdFile
        * @param {File} sysInvAttachment
        * @param {File} groupInvAttachment
        * @param {File} resetPwdAttachment
        * @param {{[key: string]: File}} emailSettingsFile
        * @param {{[key: string]: File}} emailSettingsAttachement
        * @returns {GroupDownloadDto}
    ******************************************************************************************************/
    Post: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("group", JSON.stringify(data.group));
        if (data.media)
            fd.append("media", data.media);
        if (data.sysInvFile)
            fd.append("sysInvFile", data.sysInvFile);
        if (data.groupInvFile)
            fd.append("groupInvFile", data.groupInvFile);
        if (data.resetPwdFile)
            fd.append("resetPwdFile", data.resetPwdFile);
        if (data.sysInvAttachment)
            fd.append("sysInvAttachment", data.sysInvAttachment);
        if (data.groupInvAttachment)
            fd.append("groupInvAttachment", data.groupInvAttachment);
        if (data.resetPwdAttachment)
            fd.append("resetPwdAttachment", data.resetPwdAttachment);
        _.forEach(data.emailSettingsFile, function (val, key) { return fd.append(key, val); });
        _.forEach(data.emailSettingsAttachement, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/{parent}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group/{groupid}" and http method "PATCH" to call the back-end.
    
        * @param {string} groupid
        * @param {GroupUploadDto} group
        * @param {File} media
        * @param {File} sysInvFile
        * @param {File} groupInvFile
        * @param {File} resetPwdFile
        * @param {File} sysInvAttachment
        * @param {File} groupInvAttachment
        * @param {File} resetPwdAttachment
        * @param {{[key: string]: File}} emailSettingsFile
        * @param {{[key: string]: File}} emailSettingsAttachement
        * @returns {GroupDownloadDto}
    ******************************************************************************************************/
    UpdateGroup: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("group", JSON.stringify(data.group));
        if (data.media)
            fd.append("media", data.media);
        if (data.sysInvFile)
            fd.append("sysInvFile", data.sysInvFile);
        if (data.groupInvFile)
            fd.append("groupInvFile", data.groupInvFile);
        if (data.resetPwdFile)
            fd.append("resetPwdFile", data.resetPwdFile);
        if (data.sysInvAttachment)
            fd.append("sysInvAttachment", data.sysInvAttachment);
        if (data.groupInvAttachment)
            fd.append("groupInvAttachment", data.groupInvAttachment);
        if (data.resetPwdAttachment)
            fd.append("resetPwdAttachment", data.resetPwdAttachment);
        _.forEach(data.emailSettingsFile, function (val, key) { return fd.append(key, val); });
        _.forEach(data.emailSettingsAttachement, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/{groupid}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group/users/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<UserDownloadDto, PagingTokenContainer>}
    ******************************************************************************************************/
    GroupUsers: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.token !== undefined)
            fd.append("token", JSON.stringify(data.token));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/users/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group/{groupid}/update/attributes" and http method "PATCH" to call the back-end.
    
        * @param {string} groupid
        * @param {GroupAttributesDto} dto
        * @returns {GroupDownloadDto}
    ******************************************************************************************************/
    UpdateAttributes: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/{groupid}/update/attributes", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group/definition/{groupId}/{includeOld?}" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @param {boolean} includeOld
        * @returns {ExtendedDataCollection<GroupAssignmentDefinitionDownloadDto, UserShortInfoDownloadDto[]>}
    ******************************************************************************************************/
    GetAssignmentDefinitons: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/definition/{groupId}/{includeOld?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group/definition/create" and http method "POST" to call the back-end.
    
        * @param {GroupAssignmentDefinitionUploadDto} dto
        * @returns {GroupAssignmentDefinitionDownloadDto}
    ******************************************************************************************************/
    AddAssignmentDefinitons: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/definition/create", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.dto
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group/definition/{id}" and http method "PATCH" to call the back-end.
    
        * @param {GroupAssignmentDefinitionUploadDto} dto
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    ChangeAssignmentDefinitons: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/definition/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.dto
        });
    },
    /*****************************************************************************************************
        * Is using route "api/group/definition/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    DeleteAssignmentDefinitons: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/group/definition/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=GroupController.js.map